module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Space Gray Aluminum + Black Closed.6e271f09.png";